import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBullhornOutline = function SvgBullhornOutline(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9.126 7.665 4.717 10.796c.146.335.175.708.083 1.053s-.3.64-.586.834a1.4 1.4 0 0 1-.982.223 1.54 1.54 0 0 1-.916-.492l-3.81-4.254m0 0a3.4 3.4 0 0 1-2.152-.81 3.7 3.7 0 0 1-1.229-2.024A3.57 3.57 0 0 1 4.5 10.67c.34-.71.91-1.266 1.613-1.574l1.4-.611c3.13-1.368 5.387-3.541 5.942-5.483l4.942 11.314c-1.801-.912-4.928-.734-8.06.634l-1.4.611c-.41.18-.854.27-1.306.265m9.353-4.743a2.43 2.43 0 0 0 1.31-1.418 2.73 2.73 0 0 0-.078-2.007 2.73 2.73 0 0 0-1.42-1.421 2.43 2.43 0 0 0-1.93-.003z"
    })));
};

export { SvgBullhornOutline as ReactComponent };
//# sourceMappingURL=BullhornOutline.svg.es.js.map
